import {
  ShowFetchActionManager,
  MediaFileActionManager,
  EpisodeFetchActionManager,
  EpisodeUpdateActionManager,
  EpisodeCreateActionManager,
  EpisodeValidateCreateActionManager,
  EpisodeValidateUpdateActionManager,
} from "../../action_managers/shows";

import { connect } from "react-redux";
import { change } from "redux-form";
import { withRouter } from "react-router";
import EpisodeFormModal from "./episode_form_modal";
import UploadModalActionManager from "../../action_managers/upload_modal";
import { showMessageWithTimeout } from "../../actions/app";
import messageType from "../../constants/message_types";
import { uploadModalProgress } from "../../actions/upload_modal";
import { showModal } from "../../actions/modal";
import { UPLOAD_INTERIM } from "./modal_root";

function mapStateToProps(state) {
  var props = {
    user: state.user.user,
    episodesByShow: state.episodesByShow,
    progress: state.mediaFileUpload.progress,
    mediaFiles: state.mediaFiles,
    shows: state.shows,
    isLoading: state.mediaFileUpload.isLoading,
    imageUploader: state.imageUploader,
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  return {
    fetchEpisode: (showUUID, episodeUUID, user) => {
      return dispatch(new EpisodeFetchActionManager({ showUUID, episodeUUID, user }).run());
    },
    fetchMediaFile: (mediaFileUUID, authToken) => {
      if (mediaFileUUID) {
        return dispatch(new MediaFileActionManager({ mediaFileUUID, authToken }).run());
      }
    },
    fileUpload: (file, fileName, user, progressCallback) => {
      return dispatch(
        new UploadModalActionManager({
          file,
          fileName,
          authToken: user.authToken,
          progressCallback,
        }).run()
      );
    },
    uploadProgress: progress => {
      return dispatch(uploadModalProgress(progress));
    },
    setError: errorMessage => {
      dispatch(showMessageWithTimeout(errorMessage, messageType.Error));
    },
    fetchShow: (showUUID, user) => {
      dispatch(new ShowFetchActionManager({ showUUID, user }).run());
    },
    updateEpisode: (episode, user, silent) => {
      return dispatch(new EpisodeUpdateActionManager({ episode, user, silent }).run());
    },
    createEpisode: (episode, user, silent) => {
      return dispatch(new EpisodeCreateActionManager({ episode, user, silent }).run());
    },
    validateEpisodeCreate: (episode, user) => {
      return dispatch(new EpisodeValidateCreateActionManager({ episode, user }).run());
    },
    validateEpisodeUpdate: (episode, user) => {
      return dispatch(new EpisodeValidateUpdateActionManager({ episode, user }).run());
    },
    setImageFileUUID: (mediaFileUUID, mode) => {
      return dispatch(change("episode-" + mode, "imageMediaFileUUID", mediaFileUUID));
    },
    setContentFileUUID: (mediaFileUUID, mode) => {
      return dispatch(change("episode-" + mode, "contentMediaFileUUID", mediaFileUUID));
    },
    setImageFileData: (mode, file) => {
      return dispatch(change("episode-" + mode, "imageFileData", file));
    },
    setAudioFileData: (mode, file) => {
      return dispatch(change("episode-" + mode, "audioFileData", file));
    },
    showMessageWithTimeout: (message, type) => {
      return dispatch(showMessageWithTimeout(message, type));
    },
    openLoadingModal: props => dispatch(showModal(UPLOAD_INTERIM, props)),
  };
}

const EpisodeFormModalWrapper = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EpisodeFormModal)
);

export default EpisodeFormModalWrapper;
